import { SpinnerCircular } from "spinners-react";
import * as S from "../styles";

function DadosMotorista({ motorista, dados }) {
  if (!dados || dados.length === 0) {
    return <></>;
  }
  return (
    <S.DetailBox>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
        <div
          style={{
            width: "100px",
            height: "100px",
            overflow: "hidden", // Garante que o extra seja cortado
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 10,
          }}>
          <img
            src={dados[7]}
            alt="Descrição"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover", // Faz a imagem preencher o quadrado cortando as sobras
              objectPosition: "center", // Centraliza o corte
            }}
          />
        </div>

        <S.MotoristaBox>
          <S.MotoristaNome>Motorista {dados[0]}</S.MotoristaNome>
          <S.MotoristaLinha>
            <S.MotoristaCarro>
              Carro {dados[2]} {dados[5]}
            </S.MotoristaCarro>
            <S.MotoristaPlaca>{(dados[1] || "").replace(/[^a-zA-Z0-9]/g, '')}</S.MotoristaPlaca>
          </S.MotoristaLinha>
        </S.MotoristaBox>
      </div>
    </S.DetailBox>
  );
}
export default DadosMotorista;
